import { useEffect, useState } from "react";
import { useRef } from "react";
import { AiOutlineIdcard, AiOutlineMenu, AiOutlineUser } from "react-icons/ai";
import { useStores } from "../../store/index";
import { apiLink, roles } from "../../helpers/constantVariables";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import {
  getDataFromLocalStorage,
  removeDataFromLocalStorage,
} from "../../services/localStorage";
import {
  apiGet,
  apiGetPublic,
  apiPostPut,
  apiPostPutPublic,
} from "../../api/api_methods";
import CompanyName from "../reusble_components/Employerdetails";
import { IoLocationOutline } from "react-icons/io5";
import { BsTelephone } from "react-icons/bs";
import { PrimaryButton } from "../reusble_components/buttons/primaryButton";
import { MdArrowBackIosNew } from "react-icons/md";
import { GoOrganization } from "react-icons/go";
import { getDomainForWhiteLabeling } from "../../services/white_label";
import NewPlatformPopup from "../reusble_components/popup/NewPlatformPopup";

export default function RegisterDetails({ onBack }) {
  const { UserStore } = useStores();
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [orgValue, setorgValue] = useState();
  const [org, setOrg] = useState();
  const [clusterSelected, setClusterSelected] = useState();
  const [showNewPlatformPopup, setShowNewPlatformPopup] = useState(false);
  const [pendingNavigation, setPendingNavigation] = useState(false);

  useEffect(() => {
    // Get clusterId from URL

    getOrg();
  }, []);
  const getOrg = async () => {
    const res = await apiGetPublic("/cluster/all-clusters");

    if (res.status === 200) {
      setOrg(res.body?.data?.clusters || []);
      const url = window.location.href;
      const clusterId = url.split("clusterId=")[1];
      console.log("this is clusterId", clusterId);
      if (clusterId && res.body?.data?.clusters) {
        // Check if org has a value
        // Filter the cluster id from response
        const cluster = res.body?.data?.clusters.filter(
          (orgItem) => orgItem._id === clusterId,
        );
        if (cluster.length < 1) {
          console.log(cluster.length);
          // If no cluster found by ID, try to set Reaidy as default
          const reaidyCluster = res.body?.data?.clusters.find(
            (org) => org.listing && org?.registeredCompanyName === "Reaidy.io",
          );
          if (reaidyCluster) {
            setClusterSelected([reaidyCluster]);
            setorgValue(reaidyCluster._id);
          }
          return;
        }
        console.log("this is cluster", cluster);
        setClusterSelected(cluster);
        setorgValue(clusterId);
        console.log(clusterId);
      } else {
        // No clusterId in URL, try to set Reaidy as default
        const reaidyCluster = res.body?.data?.clusters.find(
          (org) => org.listing && org?.registeredCompanyName === "Reaidy.io",
        );
        if (reaidyCluster) {
          setClusterSelected([reaidyCluster]);
          setorgValue(reaidyCluster._id);
        }
      }
    }
  };

  const navigateUsingRole = async (role) => {
    /* ------------------- REDIRECT TO THE URL IF IT IS THERE ------------------- */
    const redirectUrl = await getDataFromLocalStorage("redirectUrl");
    console.log(redirectUrl);
    if (redirectUrl) {
      removeDataFromLocalStorage("redirectUrl");
      window.location.href = redirectUrl;
      return;
    }

    /* ----------------------------------- XXX ---------------------------------- */

    switch (role) {
      case "student":
        return navigate("/dashboard/dashboard");
      case "company":
      case "consultancy":
        return navigate("/company/dashboard");

      default:
        return navigate("/dashboard/dashboard");
        break;
    }
  };

  return (
    <div className="flex w-[100%] h-[100vh]  justify-center items-center bg-[#F8F2E9]">
      {UserStore.role === roles[0].id ? (
        <> {JobseekerRegister()}</>
      ) : (
        <> {RecruitorRegister()}</>
      )}
    </div>
  );

  function JobseekerRegister() {
    const registerUser = async (e) => {
      e.preventDefault();
      const user_google = JSON.parse(localStorage.getItem("user_google"));
      const gId = JSON.parse(localStorage.getItem("user"))?._id
        ? JSON.parse(localStorage.getItem("user"))?._id
        : JSON.parse(localStorage.getItem("users"))?._id;
      const roleId = UserStore?.role;
      const body = {
        name: name,
        role: roleId,
        // skills: skills,
        mobile: phone,
        city: city,
        // college: collegeRef.current?.value,
        gender: genderInputRef.current?.value,
        cluster: e.target.org.value,
      };
      try {
        setIsSubmitting(true);
        apiPostPutPublic(body, `/user/user-with-id/${gId}`, "PUT")
          .then((res) => {
            console.log(res);
          })
          .catch((err) => {
            console.log(err);
            alert("Something went wrong. Please try again later. error: 29");
          });
      } catch (error) {
        console.error(error);
        alert("Something went wrong. Please try again later. error: 33");
      }
    };

    const nameInputRef = useRef(null);
    const genderInputRef = useRef(null);
    const skillInputRef = useRef(null);
    const [skills, setSkills] = useState([]);
    const phoneinputref = useRef(null);
    const cityRef = useRef(null);
    const collegeRef = useRef(null);
    const [showSkills, setShowSkills] = useState(true);
    const [name, setName] = useState("");
    const [phone, setPhone] = useState("");
    const [city, setCity] = useState("");

    const addSkills = () => {
      if (skillInputRef.current.value !== "") {
        setSkills([...skills, skillInputRef.current?.value]);
        skillInputRef.current.value = "";
      }
    };

    const handleNewPlatformCancel = () => {
      setShowNewPlatformPopup(false);
    };

    const handleNewPlatformConfirm = () => {
      const user = JSON.parse(localStorage.getItem("user"));
      localStorage.clear();
      if (pendingNavigation === "student") {
        window.location.href = `https://user.reaidy.io/${user._id}`;
        return;
      }
    };

    const removeSkill = (skill) => {
      setSkills(skills.filter((item) => item !== skill));
    };

    const [gender, setGender] = useState("");

    const handleGenderChange = (event) => {
      setGender(event.target.value);
    };

    return (
      <div className="flex flex-col md:w-[80%] lg:w-[80%] w-[100%] bg-[#F8F2E9]">
        <div className="flex justify-center">
          {/* <img
            src={getLogoBySubdomain()}
            className=" w-56  mt-32 object-cover"
          ></img> */}
        </div>

        <NewPlatformPopup
          isOpen={showNewPlatformPopup}
          onClose={handleNewPlatformCancel}
          onConfirm={handleNewPlatformConfirm}
          onCancel={handleNewPlatformCancel}
        />

        <form
          onSubmit={registerUser}
          className=" flex flex-col items-center mx-auto mt-3 gap-5 w-fit   rounded-lg "
        >
          <div
            className="flex items-center justify-start  -mt-[10%] w-full cursor-pointer"
            onClick={() => onBack()}
          >
            <MdArrowBackIosNew className="text-black text-sm mr-1" />
            <span className="text-xs text-black font-bold">Back</span>
          </div>
          <div className="flex flex-col mx-auto gap-y-3 justify-center items-start ">
            <p className="text-xl text-start ml-2">
              Enter your Details{" "}
              <span className="text-[#ff6b00]">Register</span>
            </p>
            {/* <label className="text-text_color4">Name</label>
            <input
              required
              placeholder="Enter Your Name"
              ref={nameInputRef}
              type="text"
              className="border border-gray-500 rounded-lg w-full px-2 py-2 focus:outline-none"
            />
            <label className="text-text_color4">Phone number</label>
            <input
              required
              placeholder="9999999999"
              ref={phoneinputref}
              type="number"
              className="border border-gray-500 rounded-lg w-full px-2 py-2 focus:outline-none"
            /> */}
            <div>
              <h1 className="w-50 h-3  ml-2 font-bold ">Enter Your Name</h1>
              <CompanyName
                placeholder="Enter Your Name"
                required
                type="text"
                icon={
                  <AiOutlineUser className="text-black text-lg mr-4 ml-1" />
                }
                ref={nameInputRef}
                action={(e) => {
                  console.log(e.target.value);
                  setName(e.target.value);
                }}
              />
            </div>
            {/* <label className="text-text_color4">Organization/College</label>
            {clusterSelected ? (
              <>
                <select
                  name="org"
                  id="org"
                  value={clusterSelected[0]?._id}
                  className="border border-gray-500 rounded-lg w-full px-2 py-2 focus:outline-none"
                >
                  <option value={clusterSelected[0]?._id}>
                    {" "}
                    {clusterSelected[0]?.registeredCompanyName}{" "}
                  </option>
                </select>
              </>
            ) : (
              <select
                name="org"
                id="org"
                onChange={(e) => {
                  setorgValue(e.target.value);
                  console.log(e.target.value);
                }}
                className="border border-gray-500 rounded-lg w-full px-2 py-2 focus:outline-none"
              >
                {org
                  ?.filter(
                    (org) =>
                      org.listing && org?.registeredCompanyName !== "Reaidy.io"
                  )
                  .map((org, index) => (
                    <option key={index} value={org?._id}>
                      {org?.registeredCompanyName}
                    </option>
                  ))}

                {org
                  ?.filter(
                    (org) =>
                      org.listing && org?.registeredCompanyName === "Reaidy.io"
                  )
                  .map((org, index) => (
                    <option key={index} value={org?._id}>
                      other
                    </option>
                  ))}
              </select>
            )}

            <label className="text-text_color4">City</label>
            <input
              required
              placeholder="Enter Your name of the city"
              ref={cityRef}
              type="text"
              className="border border-gray-500 rounded-lg w-full px-2 py-2 focus:outline-none"
            /> */}
            {/* <label className="text-text_color4">College Name</label>
            <input
              required
              placeholder="Enter Your College Name"
              ref={collegeRef}
              type="text"
              className="border border-gray-500 rounded-lg w-full px-2 py-2 focus:outline-none"
            /> */}
            <div>
              <h1 className="w-50 h-3  ml-2 font-bold ">
                {" "}
                Select Your Organization
              </h1>
              {/* <CompanyName
                placeholder="Enter Your College Name"
                required
                type="text"
                icon={
                  <AiOutlineIdcard className="text-black text-lg mr-4 ml-1" />
                }
              /> */}
              {clusterSelected ? (
                <div className="flex items-center border bg-white rounded-lg p-2 w-80  mt-4">
                  <GoOrganization className="text-black text-lg mr-4 ml-1" />
                  <select
                    name="org"
                    id="org"
                    value={clusterSelected[0]?._id}
                    className="flex-1 outline-none bg-white"
                  >
                    <option value={clusterSelected[0]?._id}>
                      {" "}
                      {clusterSelected[0]?.registeredCompanyName}{" "}
                    </option>
                  </select>
                </div>
              ) : (
                <div className="flex items-center border bg-white rounded-lg p-2 w-80  mt-4">
                  <GoOrganization className="text-black text-lg mr-4 ml-1" />
                  <select
                    name="org"
                    id="org"
                    onChange={(e) => {
                      setorgValue(e.target.value);
                      console.log(e.target.value);
                    }}
                    value={orgValue}
                    className="flex-1 outline-none bg-white"
                  >
                    {org
                      ?.filter(
                        (org) =>
                          org.listing &&
                          org?.registeredCompanyName === "Reaidy.io",
                      )
                      .map((org, index) => (
                        <option key={`reaidy-${index}`} value={org?._id}>
                          {org?.registeredCompanyName}
                        </option>
                      ))}
                    {org
                      ?.filter(
                        (org) =>
                          org.listing &&
                          org?.registeredCompanyName !== "Reaidy.io",
                      )
                      .map((org, index) => (
                        <option key={`other-${index}`} value={org?._id}>
                          {org?.registeredCompanyName}
                        </option>
                      ))}
                  </select>
                </div>
              )}
            </div>
            <div>
              <h1 className="w-50 h-3  ml-2 font-bold "> Mobile Number</h1>
              <CompanyName
                placeholder="Enter Your mobile number"
                required
                type="number"
                ref={phoneinputref}
                icon={<BsTelephone className="text-black text-lg mr-4 ml-1" />}
                action={(e) => {
                  console.log(e.target.value);
                  setPhone(e.target.value);
                }}
              />
            </div>
            <div>
              <h1 className="w-50 h-3  ml-2 font-bold "> Location</h1>
              <CompanyName
                placeholder=" City"
                required
                type="text"
                ref={cityRef}
                icon={
                  <IoLocationOutline className="text-black text-lg mr-4 ml-1" />
                }
                action={(e) => {
                  console.log(e.target.value);
                  setCity(e.target.value);
                }}
              />
            </div>
            {/* <label className="text-text_color4" htmlFor="gender">
              Gender
            </label>
            <select
              className="border border-gray-500 rounded-lg w-full px-2 py-2 focus:outline-none"
              required
              ref={genderInputRef}
              value={gender}
              onChange={handleGenderChange}
            >
              <option value="">Select Gender</option>
              <option value="male">Male</option>
              <option value="female">Female</option>
              <option value="other">Other</option>
            </select> */}
            {/* <label className="text-text_color4" htmlFor="skills">
              skills you have{" "}
            </label>
            <div className="flex flex-row w-full">
              <input
                placeholder="Enter Your Skills"
                type="text"
                ref={skillInputRef}
                className="w-full p-2 border  border-border2 rounded-[10px] focus:outline-none"
              />
              <button
                onClick={() => addSkills()}
                type="button"
                className="bg-primary  text-bg3 ml-2 py-2 px-4 rounded-[10px] cursor-pointer transition-colors duration-300"
              >
                Add
              </button>
            </div>
            <>
              {showSkills && (
                <div className="flex  flex-wrap gap-3 h-auto mx-3 w-[100%]">
                  {skills.map((skill, index) => (
                    <div
                      className="flex relative flex-row justify-end pt-2"
                      key={index}
                    >
                      <div className=" cursor-pointer absolute w-4 h-4 text-xs text-bg3 text-center rounded-full mx-1 my-1 bg-text_color3" onClick={() => { removeSkill(skill) }}>x</div>
                      <AiFillCloseCircle
                        className="absolute cursor-pointer md:my-0 lg:my-0 mb-2 mr-[-10px]"
                        onClick={() => {
                          removeSkill(skill);
                        }}
                      />
                      <p className="text-[15px]   rounded-lg  bg-primary  text-bg3 py-1 px-4">
                        {skill}
                      </p>
                    </div>
                  ))}
                </div>
              )}
            </> */}
            {/* <label className="text-text_color4">Phone number</label>
            <input
              required
              type="text"
              ref={phoneinputref}
              className="border focus:outline-none border-gray-500 rounded-lg w-full px-2 py-2"
            />

            <label className="text-text_color4">City</label>
            <input
              required
              type="text"
              ref={cityRef}
              className="border focus:outline-none border-gray-500 rounded-lg w-full px-2 py-2"
            /> */}
            {/* <div className="w-full"> */}
            {/* <div className="flex w-full">
              <LoginButton
                buttonName={isSubmitting ? "Loading..." : "Next"}
                color="#FF6800"
                rounded="lg"
                padding="24"
                onClick={registerUser}
              />
            </div> */}

            {/* </div> */}
          </div>
          {/* <button
            type="submit"
            className="px-20 my-3 py-3 rounded-full bg-primary text-white"
          >
            {isSubmitting ? "Loading..." : "Register"}
          </button> */}{" "}
          <PrimaryButton
            type="submit"
            buttonName="Login"
            color="#FF6800"
            padding="24"
            rounded={"lg"}
          />
        </form>
      </div>
    );
  }

  function RecruitorRegister() {
    const phoneinputref = useRef(null);
    const nameInputref = useRef(null);
    const positionref = useRef(null);
    const industryref = useRef(null);
    const [name, setName] = useState("");
    const [phone, setPhone] = useState("");
    const [position, setPosition] = useState("");
    const [industry, setIndustry] = useState("");

    const registerUser = async (e) => {
      e.preventDefault();
      const user_google = JSON.parse(localStorage.getItem("user_google"));
      const gId = JSON.parse(localStorage.getItem("user"))?._id
        ? JSON.parse(localStorage.getItem("user"))?._id
        : JSON.parse(localStorage.getItem("users"))?._id;
      const roleId = UserStore?.role;
      const body = {
        name: name,
        role: roleId,
        position: position,
        mobile: phone,
        industry: industry,
        newCompany: true,
      };
      try {
        setIsSubmitting(true);
        const res = await apiPostPutPublic(
          body,
          `/user/user-with-id/${gId}`,
          "PUT",
        );
        if (res.status === 200) {
          localStorage.setItem("user", JSON.stringify(res?.body?.data));
          localStorage.removeItem("register");
          if (
            res?.body?.data?.role?.role === "student" &&
            getDomainForWhiteLabeling() === "app.reaidy.io"
          ) {
            setPendingNavigation(res?.body?.data?.role?.role);
            setShowNewPlatformPopup(true);
            return;
          }

          return navigateUsingRole(res?.body?.data?.role?.role);
        }
      } catch (error) {
        console.error(error);
        alert(error.body.message);
      }
    };

    return (
      <div className="flex bg-[#F8F2E9] flex-col md:w-[80%] lg:w-[80%] w-[100%] ">
        <div className="flex justify-center">
          {/* <img
            src={getLogoBySubdomain()}
            className=" w-56  mt-auto object-cover"
          ></img> */}
        </div>

        <form
          onSubmit={registerUser}
          className="bg-[#F8F2E9] mx-auto w-fit  gap-5 mt-3  flex flex-col  items-start"
        >
          <div
            className="flex items-center justify-start mb-[25%] md:mb-[15%] -mt-[10%] w-full cursor-pointer"
            onClick={() => onBack()}
          >
            <MdArrowBackIosNew className="text-black text-sm mr-1" />
            <span className="text-xs text-black font-bold">Back</span>
          </div>
          <div>
            <p className="text-xl text-start font-bold">
              Enter Your Details to{" "}
              <span className="text-[#ff6b00]">Register</span>
            </p>
          </div>
          {/* <label className="text-text_color4">Company name</label>
            <input
              placeholder="XYZ Company"
              required
              ref={nameInputref}
              type="text"
              className="border border-gray-500 rounded-lg w-full px-2 py-2 focus:outline-none"
            /> */}
          <div>
            <h1 className="w-50 h-3  ml-2 font-bold "> Company name</h1>
            <CompanyName
              placeholder="Name of the Company"
              required
              type="text"
              icon={<AiOutlineUser className="text-black text-lg mr-4 ml-1" />}
              action={(e) => {
                console.log(e.target.value);
                setName(e.target.value);
              }}
            />
          </div>
          <div>
            <h1 className="w-50 h-3  ml-2 font-bold "> Role</h1>
            <CompanyName
              placeholder="Role"
              required
              type="text"
              icon={
                <AiOutlineIdcard className="text-black text-lg mr-4 ml-1" />
              }
              ref={positionref}
              action={(e) => {
                console.log(e.target.value);
                setPosition(e.target.value);
              }}
            />
          </div>
          <div>
            <h1 className="w-50 h-3  ml-2 font-bold "> Industry</h1>
            <CompanyName
              placeholder="Industry"
              required
              type="text"
              icon={<AiOutlineMenu className="text-black text-lg mr-4 ml-1" />}
              ref={industryref}
              action={(e) => {
                console.log(e.target.value);
                setIndustry(e.target.value);
              }}
            />
          </div>
          <div>
            <h1 className="w-50 h-3  ml-2 font-bold "> Telephone number</h1>
            <CompanyName
              placeholder="Telephone number"
              required
              type="number"
              maxLength="10"
              icon={<BsTelephone className="text-black text-lg mr-4 ml-1" />}
              ref={phoneinputref}
              action={(e) => {
                console.log(e.target.value);
                setPhone(e.target.value);
              }}
            />
          </div>
          <PrimaryButton
            buttonName={isSubmitting ? "Loading..." : "Next"}
            color="#FF6800"
            rounded="lg"
            padding="24"
            type={"submit"}
            onClick={registerUser}
          />
        </form>
      </div>
    );
  }
}
